import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { mabeSettings } from '../../../app.config';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-paginator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './paginator.component.html',
  styleUrl: './paginator.component.css'
})
export class PaginatorComponent implements OnChanges {
  @Input() totalItems: number = 0;
  @Input() itemsPerPage: number = mabeSettings.itemsPerPage;
  @Output() pageChange = new EventEmitter<number>();

  currentPage: number = 0;
  totalPages: number = 0;

  constructor(private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.calculateTotalPages();
    this.route.queryParams.subscribe(params => {
      const page = +params['page'] || 0;
      this.currentPage = page;
      this.pageChange.emit(this.currentPage);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['totalItems']) {
      this.calculateTotalPages();
      this.currentPage = 0;
    }
  }

  get visiblePages(): number[] {
    const maxVisiblePages = 7;
    const halfVisible = Math.floor(maxVisiblePages / 2);
    const totalPages = this.totalPages;

    let startPage = Math.max(this.currentPage - halfVisible, 0);
    let endPage = Math.min(this.currentPage + halfVisible, totalPages - 1);

    if (this.currentPage <= halfVisible) {
      endPage = Math.min(maxVisiblePages - 1, totalPages - 1);
    }

    if (this.currentPage + halfVisible >= totalPages) {
      startPage = Math.max(totalPages - maxVisiblePages, 0);
    }

    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    return pages;
  }


  calculateTotalPages() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);
  }

  goToPage(page: number) {
    if (page >= 0 && page < this.totalPages) {
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: { page: page },
        queryParamsHandling: 'merge'
      });
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages - 1) {
      this.goToPage(this.currentPage + 1);
    }
  }

  previousPage() {
    if (this.currentPage > 0) {
      this.goToPage(this.currentPage - 1);
    }
  }
}
